import classnames from "classnames";
import { CardOrientation } from "~/models/card";

export const ImageFrame = ({
  children,
  className,
  orientation = "vertical",
}: {
  children: React.ReactNode;
  className?: string;
  orientation?: CardOrientation;
}) => {
  return (
    <div
      className={classnames(
        orientation === "horizontal"
          ? "tw:overflow-hidden tw:rounded-tl-[20px] tw:rounded-bl-[20px] tw:h-full"
          : "tw:h-[190px] tw:overflow-hidden tw:rounded-tl-[20px] tw:rounded-tr-[20px]",
        className
      )}
    >
      {children}
    </div>
  );
};
